<emoji-mart
  [set]="'apple'"
  [autoFocus]="autoFocus()"
  (emojiSelect)="selectEmoji($event.emoji)"
  [isNative]="true"
  [perLine]="perLine()"
  [emojiSize]="emojiSize()"
  [showPreview]="showPreview()"
  [enableSearch]="enableSearch()"
  [darkMode]="state.darkMode"
  [dojoStopPropagation]
/>
